import { render, staticRenderFns } from "./CoveShedData.vue?vue&type=template&id=4c8ec2ec&scoped=true&"
import script from "./CoveShedData.vue?vue&type=script&lang=js&"
export * from "./CoveShedData.vue?vue&type=script&lang=js&"
import style0 from "./CoveShedData.vue?vue&type=style&index=0&id=4c8ec2ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8ec2ec",
  null
  
)

export default component.exports